export default {"src":"/_next/static/media/vegan.17701e5c.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};